import { useEffectEvent } from '@floating-ui/react/utils';
import { useEntityFilter } from '@risksmart-app/components/src/contexts/entityFilterContext';

import { useGetEntities } from '@/hooks/queries/entity/useGetEntities';

export interface ScopedEntity {
  id: string;
  name: string;
}

export type EntityScope = ScopedEntity[];

export const useEntityScope = (): (() => EntityScope) => {
  const { data: entities } = useGetEntities({ queryArgs: {} });

  return useEffectEvent((): EntityScope => {
    const { entityIds } = useEntityFilter.getState();
    if (!entityIds.length) {
      return [];
    }

    return entityIds.map((id) => ({
      id,
      name: entities?.entity.find((entity) => entity.Id === id)?.Name ?? '',
    }));
  });
};
